import React from "react";

import Section from "./Section";
import Navbars from "../../Layout/Navbar";

const TermsOfService = () => {
  return (
    <React.Fragment>
      <Navbars isDark={false} />
      <Section />
    </React.Fragment>
  );
};

export default TermsOfService;
